import { breakpointChangeListener } from '../listeners/breakpointChangeListener.js';

const onBreakpointChange = newBreakpoint => {
  window.dispatchEvent(new Event('BreakpointChange'));
  window.dispatchEvent(new Event(`BreakpointChange-${newBreakpoint}`));
};

export const breakpointEventService = {
  init: () => breakpointChangeListener(onBreakpointChange)
};
